
import { SellersApiRemoteService } from '../../Services/api/sellers/sellers-service'
import { IUpdateSellersPayload } from '../../Services/api/sellers/sellers.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class UpdateSellersUseCase
implements IFormUsecase<IUpdateSellersPayload, void> {
  constructor (private readonly SellersApi: SellersApiRemoteService) {}
    

  public async handle (data: IUpdateSellersPayload): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.SellersApi.update(data)

      if (response.isFailure) {
        return response
      }

      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
